export * from './preventive-maintenance-edit.component';
export * from './preventive-maintenance-edit.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-edit/index.ts